<template>
	<div class="autocomplete">
		<div class="autocomplete__field-wrapper">
			<text-field
				type="text"
				:placeholder="placeholder"
				@input="onChange"
				v-model="search"
				@keydown.down="onArrowDown"
				@keydown.up="onArrowUp"
				@keydown.enter="onEnter"
			/>
			<span v-if="search" class="fonticon fonticon--close fs--12" @click="setResult('')"></span>
			<span v-else class="autocomplete__search">Submit</span>
		</div>
		<ul
			id="autocomplete__results"
			v-show="isOpen"
			class="autocomplete__results"
		>
			<li
				class="loading"
				v-if="isLoading"
			>
				Loading results...
			</li>
			<li
				v-else
				v-for="(result, i) in results"
				:key="i"
				@click="setResult(result.label)"
				class="autocomplete__result"
				:class="{ 'is-active': i === arrowCounter }"
			>
				{{ result.label }}
			</li>
		</ul>
	</div>
</template>


<script>
import { filter } from 'lodash';

import TextField from '../atoms/TextField';

export default {
	name: 'autocomplete',

	components: {
		TextField,
	},

	props: {
		placeholder: String,
		// 'items' is an array of objects structured as: {
		// 	search - string to search
		// 	label - string to show in the results dropdown
		// 	value - optional value to omit on select. If not set, label is returned
		// }
		items: {
			type: Array,
			required: false,
			default: () => [],
		},
		isAsync: {
			type: Boolean,
			required: false,
			default: false,
		},
	},

	data() {
		return {
			isOpen: false,
			results: [],
			search: '',
			isLoading: false,
			arrowCounter: -1,
		};
	},

	methods: {
		onChange() {
			var self = this;

			// Is the data given by an outside ajax request?
			if (self.isAsync) {
				self.isLoading = true;
			} else {
				// Let's	our flat array
				self.filterResults();
				self.isOpen = true;
			}
		},

		filterResults() {
			// first uncapitalize all the things
			this.results = this.items.filter((item) => {
				return item.search.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
			});
		},
		setResult(result) {
			var self = this;

			self.search = result;
			self.isOpen = false;

			// Let's warn the parent that a change was made
			var result = filter(self.results, {label: self.search});
			if(result && result.length > 0)
			{
				if(result[0].hasOwnProperty('value'))
				{
					self.$emit('input', result[0].value);
				}
				else
				{
					self.$emit('input', self.search)
				}
			}
			// No match so reset any previous match state
			else
			{
				self.$emit('input', null)
			}
		},
		onArrowDown(evt) {
			if (this.arrowCounter < this.results.length) {
				this.arrowCounter = this.arrowCounter + 1;
			}
		},
		onArrowUp() {
			if (this.arrowCounter > 0) {
				this.arrowCounter = this.arrowCounter -1;
			}
		},
		onEnter() {
			if(this.results[this.arrowCounter])
			{
				this.setResult(this.results[this.arrowCounter].label);
			}
			else
			{
				this.setResult(this.search);
			}
			this.arrowCounter = -1;
		},
		handleClickOutside(evt) {
			if (!this.$el.contains(evt.target)) {
				this.isOpen = false;
				this.arrowCounter = -1;
			}
		}
	},
	watch: {
		items: function (val, oldValue) {
			// actually compare them
			if (val.length !== oldValue.length) {
				this.results = val;
				this.isLoading = false;
			}
		},
	},
	mounted() {
		document.addEventListener('click', this.handleClickOutside)
	},
	destroyed() {
		document.removeEventListener('click', this.handleClickOutside)
	}
};
</script>

<style lang="scss">
	@import "src/scss/toolkit";

	$c: ".autocomplete";
	#{$c}
	{
		position: relative;

		&__field-wrapper
		{
			display: flex;
			flex-wrap: nowrap;
			width: 100%;
			align-content: center;
			align-items: center;
			padding: { left: 16px; right: 16px; }
			overflow: hidden;

			@include css-variables
			{
				border: 1px solid var(field-border-color);
				border-radius: calc(1px * #{var(field-border-radius)});
			}

			.field--text
			{
				flex-grow: 1;

				.field__element
				{
					border-width: 0;
					padding-left: 0;
				}
			}
		}

		&__search
		{
			@include extend(lato-bold);
			text-transform: uppercase;
			font-size: 10px;
			line-height: 1.2;
			color: palette(blue);
		}

		&__results
		{
			position: absolute;
			padding: 0;
			margin: 0;
			margin-top: calc(-1px * #{var(field-border-radius)});
			padding-top: calc(1px * #{var(field-border-radius)});
			border: 1px solid $field-border-color;
			border-top-width: 0;
			max-height: 50vh;
			overflow: auto;
			width: 100%;
			z-index: 500;
			background-color: white;
		}

		&__result
		{
			list-style: none;
			text-align: left;
			padding: 2px rem(10);
			cursor: pointer;
			font-size: 0.9em;

			&.is-active,
			&:hover
			{
				background-color: palette(blue);
				color: white;
			}
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/molecules/Autocomplete.vue